import { IFormErrors } from '@interfaces/IFormsErrors';
import { IGroup, IGroups, IUserAccessToGroup } from '@interfaces/IGroup';

export interface IGroupsViewState {
  groups: IGroups | null;
  isLoading: boolean;
  errors: IFormErrors | null;
  courseGroups: {
    data: IGroups | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  group: {
    detail: IGroup | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  studentsTransfersGroups: {
    data: IGroups | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  userAccess: {
    data: IUserAccessToGroup | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
}

export const initialGroupsViewState: IGroupsViewState = {
  groups: null,
  isLoading: false,
  errors: null,
  courseGroups: {
    data: null,
    isLoading: false,
    errors: null,
  },
  group: {
    detail: null,
    isLoading: false,
    errors: null,
  },
  studentsTransfersGroups: {
    data: null,
    isLoading: false,
    errors: null,
  },
  userAccess: {
    data: null,
    isLoading: false,
    errors: null,
  },
};
